exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-driving-green-logo{display:block;height:38px;width:228px}", ""]);

// exports
